module.exports = __webpack_public_path__ + "img/themes-4k-gbwhatsdroid.5bc69058.webp";